import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useGetBlogByIdQuery } from "../../../services/blog/blogApiSlice";

import { BlogDetailForm } from "../../../component/blogs/blogsDetail/BlogDetailForm";
import classes from "./blogDetailPage.module.css";
import {
  useDeleteBlogMutation,
  useUpdateBlogMutation,
} from "../../../services/blog/blogMutationAPiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";
import { toast } from "react-toastify";
import { ddMMyyyyToTimestamp } from "../../../utils/dateFormatter";

export const BlogDetailPage = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();

  const {
    data: blogDetail,
    isLoading,
    isError,
    isSuccess,
  } = useGetBlogByIdQuery(blogId);

  const [updateBlog, { isLoading: isUpdating }] = useUpdateBlogMutation();
  const [deleteBlog, { isLoading: isDeleting }] = useDeleteBlogMutation();

  const handleUpdate = async (values) => {
    try {
      const payload = {
        ...values,
        id: blogId,
        publishing_date: values.publishing_date
          ? ddMMyyyyToTimestamp(values.publishing_date)
          : null,
      };
      const response = await updateBlog(payload).unwrap();

      toast.success(
        response?.message?.displayMessage || "Blog Updated Successfully"
      );
      navigate("/blogs");
      console.log(payload)
    } catch (err) {
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to update blog"
      );
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteBlog(blogId).unwrap();
      toast.success(
        response?.message?.displayMessage || "Blog Deleted Successfully"
      );
      navigate("/blogs"); // redirect to blog list after delete
    } catch (err) {
      console.error("Delete failed", err);
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to delete blog"
      );
    }
  };

  return isSuccess ? (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>{`Edit Blog ID:  ${blogId}`}</h2>
      <BlogDetailForm
        initialValues={blogDetail}
        onSubmit={handleUpdate}
        onDelete={handleDelete}
        isSubmitting={isUpdating}
        isDeleting={isDeleting}
      />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
